import React from 'react'

import PropTypes from 'prop-types'

import { search } from '@galo-monitor/icons'
import colors from '@galo-monitor/styles/colors'
import InputIcon from '@galo-monitor/web-components/InputIcon'

import useStyles from './styles'

const InputSearch = (props) => {
  const { label, ...rest } = props

  const classes = useStyles()

  return (
    <InputIcon
      { ...rest }
      icon={ search }
      label={ label }
      classes={ classes }
      color={ colors.darkGrey }
      adornmentStyle={ {
        marginRight: 12
      } }
    />
  )
}

InputSearch.propTypes = {
  label: PropTypes.string
}

InputSearch.defaultProps = {
  label: ''
}

export default InputSearch
